import { TopicPart } from "../entities/TopicPart";
import { htmlToRawText } from "../../../utils/stringUtils";
import { t } from "i18next";

const field = (
    key: string,
    value: string | null | undefined,
    multiline = false,
) => {
    if (!value?.trim()) return null;
    return t(key) + (multiline ? " :\n" : " : ") + value;
};

export function buildTopicPartMarkdown(topicPart: TopicPart): string {
    if (!topicPart) return "";

    const parts: string[] = [];

    if (topicPart.title) {
        parts.push(topicPart.title);
    }

    const description = field(
        "topicPart.field.description",
        topicPart.description,
    );
    if (description) parts.push(description);

    const contentText = htmlToRawText(topicPart.contentText);
    const formattedContentText = field(
        "topicPart.field.contentText",
        contentText,
        true,
    );
    if (formattedContentText) parts.push(formattedContentText);

    const additionalText = htmlToRawText(topicPart.additionalText);
    const formattedAdditionalText = field(
        "topicPart.field.additionalText",
        additionalText,
        true,
    );
    if (formattedAdditionalText) parts.push(formattedAdditionalText);

    if (
        topicPart.topicPartQuestions &&
        topicPart.topicPartQuestions.length > 0
    ) {
        for (const question of topicPart.topicPartQuestions) {
            if (question.text) {
                const answers =
                    question.answers && question.answers.length > 0
                        ? " \n" + question.answers?.join(", ")
                        : "";

                const questionText = field(
                    "topicPartQuestion.field.text",
                    question.text + answers,
                    true,
                );
                if (questionText) parts.push(questionText);
            }
        }
    }

    return parts.join("\n\n");
}

export const copyTopicPartContentUseCase = {
    async exec(
        topicPart: TopicPart,
        returnText: boolean = false,
    ): Promise<string | void> {
        const copyValue = buildTopicPartMarkdown(topicPart);

        if (returnText) {
            return copyValue;
        }

        if (!copyValue) return;

        try {
            await navigator.clipboard.writeText(copyValue);
        } catch (error) {
            console.error("Failed to copy topic part content:", error);
            throw error;
        }
    },
};
